var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div data-mount="header" class="add-list__header"></div>\n\n<div data-mount="items"></div>\n\n';
 if (!readOnly) { 
__p+='\n  <a href="javascript: null" data-action="add-another" class="add-list__add-another">\n    <i class="material-icons">add</i> Add another\n  </a>\n';
 } 
__p+='\n';
}
return __p;
};
